<div class="d-flex h-100">
  <div class="cc-restricted-dialog udex-pb-72 m-auto d-flex flex-column align-items-center"
       (click)="$event.stopPropagation()">
    <div class="d-flex w-100 justify-content-end">
      <udex-button
        class="text-black udex-my-24 udex-mx-32"
        design="Invisible"
        size="Small"
        icon="sap-icon://decline"
        accessible-role="Button"
        (click)="this.launchDialogService.closeDialog('Dialog close')"
        (keyup.enter)="this.launchDialogService.closeDialog('Dialog close')"
        dcpAutofocus
      >
      </udex-button>
    </div>
    
    <p class="body--s text-black udex-px-32 udex-mb-16"
       [innerHTML]="'registration.creditCardRestriction.individualPurchaseNotAvailableHtml' | cxTranslate"></p>
  </div>
</div>
